import React from 'react';
import css from './SectionMission.css';
import missionImage from '../../assets/becomeHostPage/houses2.webp';
import { FormattedMessage } from '../../util/reactIntl';
import { Link } from 'react-scroll';

function SectionMission() {

  return (
    <>
      <h2 className={css.sectionHeader3}>
        <FormattedMessage id="landing.missionHeadline" />
      </h2>

      <div className={css.box}>
        <p className={css.missionText}>
          <FormattedMessage id="landing.missionText" />
        </p>
        <div className={css.innerWrapper}>
          <Link to="section2" 
          smooth={true} duration={500} spy={true} exact='true' offset={-72} 
            className={css.heroButton}>
            <FormattedMessage id="sectionMission.button" />
          </Link>
          <img className={css.missionImage} src={missionImage}></img>
        </div>
      </div>
    </>
  )
}

export default SectionMission;
